<div class="inner-content">
    <div class="list">

        <p class="list-header">
            Wybierz marki i kliknij "Dalej"
        </p>

        <div class="list-item" *ngFor="let make of makes?.data; let index = index" (click)="onItemClick(make.id, $event)">

            <input type="checkbox" [(ngModel)]="model[make.id]">

            <img [src]="'/api/files/' + make.file.id" [alt]="make.name">

            <div class="name">
                {{ make.name }}
            </div>
        </div>
    </div>
</div>

<ns-floating-footer (backClick)="onGoBack()" (mainClick)="onNext()">
</ns-floating-footer>